import { AppBarGuardType, AppBarGuardObjectType } from '../type';

export const name = 'isTargetOpen';

export const fn: AppBarGuardType = (context) => context.target === 'openExpanded' || context.target === 'openShrinked';

export const guard: AppBarGuardObjectType = {
  [name]: fn,
};

export default guard;
